
































































































































import 'reflect-metadata'
import { Component, Vue } from 'vue-property-decorator'
import { ViewDataFromEmailApi } from '@/api'
import NotificationWithOutExit from "@/components/common/notification/NotificationWithOutExit.vue"

@Component({
    components: {
        'common-notification-notification': NotificationWithOutExit
    }
})
export default class EmailAlertSevenInspection extends Vue {
    loading: boolean = false
    
    isData: boolean = false
    username: string = ""
    email: string = ""
    readDate: string = ""
    projectName: string = ""
    transferDate: string = ""
    unitGroupList: any = []
    headerDate: string = ""

    startDate: string = ""
    endDate: string = ""
    customerAppointmentUnitSummary7Days: any[] = []
    customerAppointmentUnitList: any[] = []

    projectLists = [] as any

    async mounted() {
        await this.SetGetReportEmailTransfer()
    }

    async SetGetReportEmailTransfer() {
        try {
            this.loading = true
            const qs = this.$route.query
            const projectId = qs.pid ?? ""

            if (projectId === "") {
                this.loading = false
                this.notification('ไม่พบข้อมูลการนัดตรวจ โครงการ', 'warning') 
                return
            }

            const response = await ViewDataFromEmailApi.GetEmailAlertSevenInspection({ projectId: projectId })
            this.headerDate = response.readDate.split(' ')[0]
            this.username = `${response.userName}`
            this.email = `${response.email}`
            this.readDate = `${response.readDate}`
            this.projectName = `${response.projectCode} ${response.projectName}`
            this.startDate = response.startDate
            this.endDate = response.endDate

            this.customerAppointmentUnitSummary7Days = response.customerAppointmentUnitSummary7Days
            this.customerAppointmentUnitList = response.customerAppointmentUnitList

            this.unitGroupList = response.unitList
            this.loading = false

            if (this.customerAppointmentUnitList.length === 0) {
                this.isData = false
                this.notification('ไม่พบข้อมูลการนัดตรวจ โครงการ', 'warning') 
                return
            }
            this.isData = true

        } catch (error) {
            this.isData = false
            this.notification('มีข้อผิดพลาดเกิดขึ้น โปรดลองใหม่อีกครั้ง', 'warning') 
        }
    }

    notification (text: string, status: string) {
        const child = this.$refs.refNotification as any
        child.openNotification(text, status)
    }
}

